import type { PlatformComponentProps } from "@b2bportal/core-types";
import {
  RoomSelectionPage,
  useRoomSelectionPageContainer,
} from "@tenant/hotels";
import { PackagesHotelSlotProvider } from "@tenant/packages";
import { usePackageHotelShopNavigation } from "./hooks";

export const PackageRoomSelectionPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const { handlers } = usePackageHotelShopNavigation();

  const data = useRoomSelectionPageContainer({
    goToNextStep: handlers.onRoomSelection,
  });
  return (
    <PackagesHotelSlotProvider>
      <RoomSelectionPage {...data} className={className}>
        {children}
      </RoomSelectionPage>
    </PackagesHotelSlotProvider>
  );
};
